<template>
    <div class="lobbi-section" v-if="lobbiArr != null" id="menu-link-lobbi">
        <div class="container">
            <sectionTitle :options="[{ title : lobbiArr.lobbi_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: lobbiArr.lobbi_quote_img, title : lobbiArr.lobbi_quote_title, desc: lobbiArr.lobbi_quote_desc}]" class="lobbi-baner"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : lobbiArr.lobbi_desc_left, desc_right: lobbiArr.lobbi_desc_right}]" class="section-desc-column-lobbi"></sectionDescColumn>
            <lobbiImagesGrid :options="[{ cards: lobbiArr.lobbi_images}]"></lobbiImagesGrid>
            <!-- <sectionImagesMobile :options="[{ images: landArr.land_cards[0].images}]" v-if="isMobileGlobal"></sectionImagesMobile> -->
            <!-- <landImagesGrid :options="[{ cards: landArr.land_cards, grid_img : landArr.land_img}]" class="land-images-grid-mix"></landImagesGrid> -->
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import lobbiImagesGrid from '@/components/lobbi/lobbi-images-grid.vue'
    // import landImagesGrid from '@/components/landscaping/land-images-grid.vue'
    // import sectionImagesMobile from '@/components/partials/section-images-mobile.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'lobbi-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            lobbiArr: 'loadLobbiArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            lobbiImagesGrid,
            // landImagesGrid,
            // sectionImagesMobile,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/lobbi/lobbi-section.scss';
    @import '@/styles/components/lobbi/respond/lobbi-section-respond.scss';
</style>